<template>
  <div v-if="show" class="account-dialog-overlay">
    <div class="account-dialog">
      <h2 class="dialog-title">Login</h2>
      <p v-if="message" class="dialog-redirect-message">{{ message }}</p>
      <h4 class="dialog-info-instructions">Enter your email below to receive a login code.</h4>
      <form @submit.prevent="$emit('submit', loginEmail)">
        <div class="dialog-form-group">
          <input id="login-identifier" v-model="loginEmail" type="email" required class="dialog-input"
                 maxlength="254" />
        </div>
        <div class="dialog-actions">
          <button class="dialog-cancel-btn" type="button" @click="$emit('close')" :disabled="isLoading">Cancel</button>
          <button class="dialog-save-btn" type="submit" :disabled="isLoading">
            <span v-if="!isLoading">Send Code</span>
            <span v-else class="spinner"></span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginDialog',
  props: {
    show: { type: Boolean, required: true },
    isLoading: { type: Boolean, default: false },
    email: { type: String, default: '' },
    message: { type: String, default: '' }
  },
  emits: ['close', 'submit', 'update:email'],
  data() {
    return {
      loginEmail: this.email
    };
  },
  watch: {
    email(newVal) {
      this.loginEmail = newVal;
    },
    loginEmail(newVal) {
      this.$emit('update:email', newVal);
    }
  }
};
</script>

<style scoped>
.login-prompt {
  margin: 0 0 8px 0;
  color: #312d30;
  font-size: 1.5rem;
  font-family: 'LemonCupcakeBold', 'Pacifico', 'Segoe Script', 'Brush Script MT', cursive;
  font-weight: 300;
  letter-spacing: 0.01em;
}
.login-btn-block {
  display: block;
  width: fit-content;
  margin: 8px auto 0 auto;
}
.login-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 32px 24px;
  min-width: 180px;
}
.login-link h3 {
  margin: 0 0 16px 0;
}
.login-btn {
  display: inline-block;
  background: #7da47e;
  color: #fff;
  padding: 8px 20px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: background 0.2s;
  font-size: 1.13rem;
}
.login-btn:hover {
  background: #70ad73;
}
.login-link, .login-link h3, .login-btn {
  font-family: 'Quicksand', 'Segoe UI', 'Georgia', serif;
}
.dialog-redirect-message {
  color: #7da47e;
  font-size: 0.97rem;
  margin: -4px 0 10px 0;
  text-align: center;
}
</style>
